export class LicenceEventSchedule {
  id: string;
  eventId: string;
  eventStartDateTime: Date;
  eventEndDateTime: Date;
  serviceStartDateTime: Date;
  serviceEndDateTime: Date;
}
